module.exports = __webpack_public_path__ + "img/Nodata.81812422.svg";